<template>
    <div>
        <b-col class="dd" v-if="isSelectionValueType">
            <b-form-select
            class="form-control"
                id="input-default_value_select"
                v-model="default_value"
                :options="values"
                :disabled="disabled"
            >
                <template #first>
                    <b-form-select-option :value="null" disabled
                        >Select Default Value</b-form-select-option
                    >
                </template>
            </b-form-select>
        </b-col>
        <b-col v-else>
            <b-form-input
                
                :disabled="disabled"
                type="text"
                id="input-default_value_text"
                v-model="default_value"
                placeholder="Enter Default Value"
                trim
            ></b-form-input>
        </b-col>
    </div>
</template>
<script>
export default {
    data() {
        return {
            default_value: null,
        }
    },
    props: {
        disabled: {
            type: Boolean,
            default: true,
        },
        value: {},
        isSelectionValueType: {
            type: Boolean,
            default: true,
        },
        values: {
            type: Array,
            default: function () {
                return []
            },
        },
        min: {
            type: Number,
            default: 0,
        },
        max: {
            type: Number,
            default: 100,
        },
    },

    mounted() {
        this.processValue(this.value)
    },
    watch: {
        default_value: function (val) {
            this.$emit('input', val)
        },
        value: function (val) {
            this.processValue(val)
        },
    },
    methods: {
        processValue(value) {
            if (this.isSelectionValueType) {
                this.default_value = value
            } else {
                this.default_value = parseFloat(value) || 0
            }
        },
    },
}
</script>